module.exports = __webpack_public_path__ + "img/22.854a642e.png";